import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CONFIG_KEYS, StateService } from '@services/state.service';
import { MediaCaptureDialogComponent } from '../media-capture-dialog/media-capture-dialog.component';
import { MediaCaptureTypes } from '../media.utils';

@Component({
  selector: 'app-image-video',
  templateUrl: './image-video.component.html'
})
export class ImageVideoComponent {

  @Input() doctypes: any[] = [];

  @Input() label = '';

  @Input() orderid: string | number = '';

  _type = '';
  @Input() set type(t: string) {
    this._type = t;
  }

  @Output() done = new EventEmitter();

  testMode = false;

  constructor(
    private matDialog: MatDialog,
    private stateService: StateService
  ) { }

  takeVideo() {

    const options: MatDialogConfig<any> ={
      data: {
        type: this._type,
        orderId: this.orderid,
        doctypes: this.doctypes
      },
      panelClass: 'my-dialog-panel',
      position: {
        top: '5vh',
        left:'2vw'
      },
      width: this.testMode ? '50vw' : '96vw',
      //minWidth: '96vw',
      height: this.testMode ? '50vh' : '93vh',
    };

    if(this._type === MediaCaptureTypes.IMAGE) {
      options.data.convert = this.stateService.getConfigurationFor(
        CONFIG_KEYS.IMAGE_CONVERT
      );
    }

    if(!this.testMode) {
      options.minWidth ='92vw';
    }

    this.matDialog.open(
      MediaCaptureDialogComponent,
      options
    ).afterClosed().subscribe((res: any) => {
      if (res && res.id) {
        this.done.emit(res.id);
      }
    });
  }

  takePhoto() {
    this.takeVideo();
  }
}
